import { SectionWrapper } from "src/shared/Styles/Wrappers";
import styled from "styled-components";

export const BgWrapper = styled.div`
    background-color: ${({ color }) => (color ? color : "#fff")};
    padding: 36px 0;
`;

export const TeamSection = styled(SectionWrapper)``;

export const SmallTitle = styled.h3`
    font-size: 4rem;
    font-weight: 800;
    margin-bottom: 48px;

    @media screen and (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
        font-size: 3rem;
    }
    @media screen and (max-width: ${({ theme }) => theme.breakpoints.phone}) {
        font-size: 2rem;
    }
`;

export const TeamWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;

    @media screen and (max-width: ${({ theme }) => theme.breakpoints.phone}) {
        flex-direction: column;
        align-items: center;
    }
`;

export const TeamItem = styled.div`
    width: ${({ columns }) => (columns ? `calc(100% / ${columns})` : `calc(100% / 4)`)};
    padding-right: 48px;
    display: flex;
    align-items: center;
    margin-bottom: 48px;

    @media screen and (max-width: ${({ theme }) =>
            theme.breakpoints.laptop}) {
        width: ${({ columns }) => (columns ? `calc(100% / ${columns - 1})` : `calc(100% / 3)`)};
        margin-bottom: 36px;
    }

    @media screen and (max-width: ${({ theme }) =>
            theme.breakpoints.tablet_big}) {
        width: calc(100% / 3);
        margin-bottom: 36px;
    }

    @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: calc(100% / 2);
        padding-right: 8px;
    }

    @media screen and (max-width: ${({ theme }) => theme.breakpoints.phone_big}) {
        width: ${({ columns }) => (columns ? `50%` : '100%')};
        padding-right: 0;
        flex-direction: column;
        align-items: ${({ columns }) => (columns ? 'flex-start' : 'center')};
        justify-content: ${({ columns }) => (columns ? 'flex-start' : 'center')};
        text-align: ${({ columns }) => (columns ? 'left' : 'center')};
    }

    @media screen and (max-width: ${({ theme }) => theme.breakpoints.phone}) {
        width: 100%;
    }
`;

export const TeamImage = styled.div`
    width: 56px;
    height: 56px;
    border-radius: 100%;
    overflow: hidden;
    margin-right: 18px;
    flex-shrink: 0;

    .gatsby-image-wrapper {
        max-width: 100%;
        max-height: 100%;
    }

    @media screen and (max-width: ${({ theme }) => theme.breakpoints.phone_big}) {
        margin-right: 0;
    }
`;

export const TeamText = styled.div`
    display: flex;
    flex-direction: ${({ swap }) => (swap ? 'column-reverse' : 'column')};
`;

export const Position = styled.div`
    font-weight: 500;
    font-size: 1.2rem;
    margin-top: 6px;

    @media screen and (max-width: ${({ theme }) => theme.breakpoints.phone_big}) {
        font-size: 1rem;
    }
`;

export const Name = styled.div`
    font-weight: 800;
    font-size: 1.8rem;

    @media screen and (max-width: ${({ theme }) => theme.breakpoints.phone_big}) {
        font-size: 1.4rem;
        margin-top: 0;
    }
`;
